import { Component, OnInit } from '@angular/core';
import { AuthHelper } from '../../../authHelper/authHelper';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { Router } from '@angular/router';
import { configuracion } from '../../recursos/config.service';

@Component({
  selector: 'app-header-becario',
  templateUrl: './header-becario.component.html',
  styleUrls: ['./header-becario.component.css']
})
export class HeaderBecarioComponent implements OnInit {

  public usuario: string;
  public vecRoles = [];
  public selectRol: number = 1;

  constructor(private tools: ToolsService, private srvSelect: SeleccionService, private auth: AuthHelper,
    private alerti: AlertifyService, private ruta: Router, private conf: configuracion) { }

  ngOnInit() {
    // localStorage.setItem('ciUsuario', '1401320138')
    if (localStorage.getItem("localCargar") == "0") {
      window.location.reload();
      localStorage.setItem("localCargar", "1");
    }
    else {
      if (localStorage.getItem('ciUsuario') == null || localStorage.getItem('ciUsuario') == "") {
        this.salirBecas();
      }
      else {
        this.tools.ColorUsuario(0);
        //this.verificarRol(localStorage.getItem('ciUsuario'));
        this.datosCentral();
        this.selectRol = 2;
      }
    }
  }
  //OBTIENE LOS DATOS DE LA CENTRALIZADA DADO LA CEDULA
  async datosCentral() {

    const resCentral = await new Promise<any>(resolve =>
      this.srvSelect.personaCentral2Documento(localStorage.getItem('ciUsuario')).subscribe(translated => {
        resolve(translated)
      }));
    if (resCentral.success) {
      localStorage.setItem('localNombre', resCentral.listado[0]['per_nombres']);
      localStorage.setItem('localApellidos', resCentral.listado[0]['per_primerApellido'] + " " + resCentral.listado[0]['per_segundoApellido']);
      localStorage.setItem('localSexo', resCentral.listado[0]['sex_id']);

      this.usuario = resCentral.listado[0]['per_email'];
      localStorage.setItem('localUsuarioName', resCentral.listado[0]['per_nombres'] + " " + resCentral.listado[0]['per_primerApellido'] + " " + resCentral.listado[0]['per_segundoApellido']);
      localStorage.setItem('localCorreo', resCentral.listado[0]['per_email']);
      localStorage.setItem('localCorreoPer', resCentral.listado[0]['per_emailAlternativo']);
      localStorage.setItem('localEtnia', resCentral.listado[0]['etn_nombre']);
      localStorage.setItem('localCivil', resCentral.listado[0]['eci_nombre']);
      localStorage.setItem('localProcede', resCentral.listado[0]['datosprocedencia']);
      this.vecRoles.push({
        idTipo: 2, descripcion: 'Becario'
      });
      this.cargarCarreras();
    } else {
      this.salirBecas();
    }

  }
  //FUNCION DE DETERMINA LA CARRERA DONDE SE ENCUENTRA MATRICULADO EL ESTUDIANTE
  async cargarCarreras() {
    let cont: number = 0; let banRol: boolean = false;

    const resMat = await new Promise<any>(resolve =>
      this.srvSelect.gestionMatricula(1, 'na', localStorage.getItem('ciUsuario'), 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resMat.success) {
      while (cont < resMat.matricula.length && !banRol) {
        const matr = await new Promise<any>(resolve =>
          this.srvSelect.gestionMatricula(3, resMat.matricula[cont]['baseCarrera'], localStorage.getItem('ciUsuario'), 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (matr.success) {
          await this.cargarMateriasMatricula(resMat.matricula[cont]['baseCarrera'], matr.matricula[0]['strCodPeriodo']);
          localStorage.setItem('localBaseCarrera', resMat.matricula[cont]['baseCarrera']);
          localStorage.setItem('localNombFacultad', resMat.matricula[cont]['nombFacultad']);
          localStorage.setItem('localNombCarrera', resMat.matricula[cont]['nombCarrera']);
          localStorage.setItem('localSede', resMat.matricula[cont]['strSede']);

          localStorage.setItem('localFechaN', matr.matricula[0]['dtFechaNac'].split('T')[0]);
          localStorage.setItem('localCodNivel', matr.matricula[0]['strCodNivel']);
          localStorage.setItem('localCarrera', resMat.matricula[cont]['strCodCarrera']);
          localStorage.setItem('localFacultad', resMat.matricula[cont]['codFacultad']);
          localStorage.setItem('localPeriodo', matr.matricula[0]['strCodPeriodo']);
          localStorage.setItem('localEstudiante', matr.matricula[0]['codEstudiante']);
          cont = resMat.matricula.length; banRol = true;
          await this.verDatoColegio();
        }
        cont++;
      }
    }
    if (!banRol) {
      localStorage.setItem('localNombFacultad', 'na');
      localStorage.setItem('localNombCarrera', 'na');
      localStorage.setItem('localSede', 'na');
      localStorage.setItem('localFechaN', 'na');
      localStorage.setItem('localCodNivel', 'na');
      localStorage.setItem('localCarrera', 'na');
      localStorage.setItem('localFacultad', 'na');
      localStorage.setItem('localPeriodo', 'na');
      localStorage.setItem('localEstudiante', 'na');
    }
  }
  async verDatoColegio() {
    const resCol = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(8, localStorage.getItem('ciUsuario'), 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resCol.success) {
      localStorage.setItem('localNomColegio', resCol.carrera[0]['strNombre']);
      localStorage.setItem('localTipColegio', resCol.carrera[0]['strDescripcion']);
      localStorage.setItem('localTitColegio', resCol.carrera[0]['nombTitulo']);
      localStorage.setItem('localAniColegio', resCol.carrera[0]['dtFecha'].split('-')[0]);
    }
  }
  //FUNCION DE DETERMINA LAS MATERIAS CON SUS RESPECTIVAS NUMEROS DE MATRICULAS DADO LA CEDULA CARRERA Y PERIODO
  async cargarMateriasMatricula(carrera, periodo) {
    let contP = 0; let contS = 0; let contT = 0;
    const resMat = await new Promise<any>(resolve =>
      this.srvSelect.gestionMatricula(33, carrera, localStorage.getItem('ciUsuario'), periodo, 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resMat.success) {
      for (let objMatr of resMat.matricula) {
        if (objMatr.bytNumMat == 1)
          contP++;
        if (objMatr.bytNumMat == 2)
          contS++;
        if (objMatr.bytNumMat == 3)
          contT++;
        localStorage.setItem('localMatMaricula', 'Primera matrícula: ' + contP + '; Segunda matrícula: ' + contS + '; Tercera matrícula: ' + contT);
      }
    }
    else
      localStorage.setItem('localMatMaricula', '');
  }

  verificarRol(user: string) {
    this.srvSelect.gestionRoles(2, user, localStorage.getItem("idUser")).subscribe(res => {
      if (res.success) {
        this.usuario = res.roles[0]['strNombres'] + " " + res.roles[0]['strApellidos'];
        this.datosUsuario(user);
      }
      else
        this.salirBecas();
    });
  }
  datosUsuario(user: string) {
    this.srvSelect.gestionRoles(1, user, "na").subscribe(res => {
      if (res.success) {
        for (let i in res.roles) {
          this.vecRoles.push({
            idTipo: res.roles[i]['intIdRol'], descripcion: res.roles[i]['NombreRol']
          });
        }
      }
      //else  this.salirMedico();
    });
  }

  cambiaRol() {
    localStorage.setItem("localCargar", "0");
    this.ruta.navigate([this.conf.cambiaRol(this.selectRol)]);
  }
  salirBecas() {
    this.remove();
    this.ruta.navigate(['/']);
  }
  public remove() {
    window.sessionStorage.removeItem('ticketUser')
    window.sessionStorage.removeItem('loginUser')
    window.sessionStorage.removeItem('clientName')
  }
}